module.exports = __webpack_public_path__ + "static/media/spain.f5837455.svg";